export interface RepresentantTool {
  id: number;
  name: string;
  icon: string;
  link: string;
  checked: boolean;
  tag_new: boolean;
  newTool: boolean;
}

export const REPRESENTANT_TOOLS_PATH = '/representante';

const tool = (
  id: number,
  name: string,
  icon: string,
  link: string,
  extra: Partial<RepresentantTool> = {},
): RepresentantTool => ({
  id,
  name,
  icon,
  link,
  checked: true,
  tag_new: false,
  newTool: false,
  ...extra,
});

export const REPRESENTANT_DASHBOARD_TOOLS: RepresentantTool[] = [
  tool(1, 'Análise de Mercado', 'bar_chart', '/mercado'),
  tool(2, 'Concorrentes', 'concurrent', '/concorrentes'),
  tool(3, 'Fornecedores', 'fornecedores', `${REPRESENTANT_TOOLS_PATH}/fornecedores`, {
    newTool: true,
  }),
  tool(
    4,
    'Prospecção de Clientes',
    'prospeccao_clientes',
    `${REPRESENTANT_TOOLS_PATH}/prospeccao`,
    {
      newTool: true,
    },
  ),
  tool(5, 'Meus Clientes', 'meus_clientes', `${REPRESENTANT_TOOLS_PATH}/meus-clientes`, {
    newTool: true,
  }),
  tool(6, 'Kanban', 'kanban', `${REPRESENTANT_TOOLS_PATH}/kanban`, { newTool: true }),
];

export const REPRESENTANT_MENU_TOOLS = REPRESENTANT_DASHBOARD_TOOLS.filter((item) => item.newTool);
